import { render, staticRenderFns } from "./rich-text-editor.vue?vue&type=template&id=62be01c3&scoped=true&"
import script from "./rich-text-editor.vue?vue&type=script&lang=js&"
export * from "./rich-text-editor.vue?vue&type=script&lang=js&"
import style0 from "./rich-text-editor.vue?vue&type=style&index=0&id=62be01c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be01c3",
  null
  
)

export default component.exports